import { render, staticRenderFns } from "./Timebox.vue?vue&type=template&id=79ed467d&lang=pug"
import script from "./Timebox.vue?vue&type=script&lang=js"
export * from "./Timebox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports